var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useRequest } from './requestHook';
import useFetch from './useFetch';
import { order as api } from '../api';
export var toEditableOrderItem = function (orderItem) {
    var _a;
    return {
        id: orderItem.id,
        lotNumber: orderItem.offer.lotNumber,
        quantity: orderItem.quantity,
        comment: orderItem.comment,
        subTotalDiscount: orderItem.subTotalDiscount,
        typicaHandlingFeeDiscount: orderItem.typicaHandlingFeeDiscount,
        totalFeeDiscount: orderItem.totalFeeDiscount,
        offerListId: orderItem.offer.offerList.id,
        offerId: orderItem.offer.id,
        bidId: (_a = orderItem.bid) === null || _a === void 0 ? void 0 : _a.id,
        isPreOrderRequested: orderItem.isPreOrderRequested,
        isSentPreOrderMail: orderItem.isSentPreOrderMail,
    };
};
export var toEditableBid = function (bid) { return ({
    id: bid.id,
    lotNumber: bid.offer.lotNumber,
    status: bid.status,
    fobPrice: bid.fobPrice,
    fobPriceUsdPerLb: bid.fobPriceUsdPerLb,
    quantity: bid.quantity,
    bidAt: bid.bidAt,
    buyPartial: bid.buyPartial,
    createdAt: bid.createdAt,
    updatedAt: bid.updatedAt,
    offerId: bid.offer.id,
    offerListId: bid.offer.offerList.id,
}); };
export function useOrder(id) {
    var _this = this;
    var get = useRequest(api.get);
    var _a = React.useState(true), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(), order = _b[0], setOrder = _b[1];
    var _c = React.useState([]), orderItems = _c[0], setOrderItems = _c[1];
    var _d = React.useState([]), bids = _d[0], setBids = _d[1];
    var _e = React.useState(0), reloadCount = _e[0], setReloadCount = _e[1];
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, get(id)];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setOrder(response);
                        setOrderItems(response.items);
                        setBids(response.bids);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, get, setLoading, setOrder, reloadCount]);
    var reload = React.useCallback(function () { return setReloadCount(reloadCount + 1); }, [reloadCount]);
    var onOrderChanged = React.useCallback(function (order) { return setOrder(order); }, [setOrder]);
    var onOrderItemChanged = React.useCallback(function (orderItem) {
        var nextItems = orderItems.map(function (item) {
            return item.id === orderItem.id ? orderItem : item;
        });
        setOrderItems(nextItems);
    }, [orderItems]);
    var onBidChanged = React.useCallback(function (bid) {
        var nextBids = bids.map(function (b) { return (b.id === bid.id ? bid : b); });
        setBids(nextBids);
    }, [bids]);
    return {
        loading: loading,
        setLoading: setLoading,
        reload: reload,
        order: order,
        orderItems: orderItems,
        bids: bids,
        onOrderChanged: onOrderChanged,
        onOrderItemChanged: onOrderItemChanged,
        onBidChanged: onBidChanged,
    };
}
export function useFetchOrders(fixedQuery) {
    var getAll = useRequest(api.getAll);
    var buildFilterParams = function (query) {
        var q = fixedQuery;
        var officeFilter = query.filters.find(function (filter) { return filter.column.field === 'roaster.country.office.name'; });
        if (officeFilter)
            q.roaster_country_office_name_in = officeFilter.value;
        var statusFilter = query.filters.find(function (filter) { return filter.column.field === 'status'; });
        if (statusFilter)
            q.with_status = statusFilter.value;
        var paymentTimingFilter = query.filters.find(function (filter) { return filter.column.field === 'paymentTiming'; });
        if (paymentTimingFilter)
            q.with_payment_timing = paymentTimingFilter.value;
        return q;
    };
    return useFetch({ buildFilterParams: buildFilterParams, api: getAll });
}
